import React from 'react';
import { Button } from 'rsuite';
import { FormModal } from '../../common/FormModal';
import BlogPostModalContent from './BlogPostModalContent';

type CategoryOption = {
  label: string;
  value: string;
};

type Props = {
  open: boolean;
  onClose: () => void;
  postId: string;
  title: string;
  titleEn: string;
  titleDe: string;
  slug: string;
  categoryId: string;
  postedAt: Date | null;
  active: boolean;
  thumbnail: string;
  image: string;
  content: string;
  contentEn: string;
  contentDe: string;
  categories: CategoryOption[];
  setTitle: (value: string) => void;
  setTitleEn: (value: string) => void;
  setTitleDe: (value: string) => void;
  setSlug: (value: string) => void;
  setCategoryId: (value: string) => void;
  setPostedAt: (value: Date | null) => void;
  setActive: (value: boolean) => void;
  setThumbnail: (value: string) => void;
  setImage: (value: string) => void;
  setContent: (value: string) => void;
  setContentEn: (value: string) => void;
  setContentDe: (value: string) => void;
  onSave: () => void;
  errorSummary?: string[];
};

export default function EditBlogPostModal({
  open,
  onClose,
  postId,
  title,
  titleEn,
  titleDe,
  slug,
  categoryId,
  postedAt,
  active,
  thumbnail,
  image,
  content,
  contentEn,
  contentDe,
  categories,
  setTitle,
  setTitleEn,
  setTitleDe,
  setSlug,
  setCategoryId,
  setPostedAt,
  setActive,
  setThumbnail,
  setImage,
  setContent,
  setContentEn,
  setContentDe,
  onSave,
  errorSummary = [],
}: Props) {
  return (
    <FormModal
      open={open}
      onClose={onClose}
      title="Редагувати пост"
      errorSummary={errorSummary}
      footer={
        <>
          <Button onClick={onSave} appearance="primary">
            Зберегти
          </Button>
          <Button onClick={onClose} appearance="subtle">
            Скасувати
          </Button>
        </>
      }
    >
      <BlogPostModalContent
        postId={postId}
        title={title}
        titleEn={titleEn}
        titleDe={titleDe}
        slug={slug}
        categoryId={categoryId}
        postedAt={postedAt}
        active={active}
        thumbnail={thumbnail}
        image={image}
        content={content}
        contentEn={contentEn}
        contentDe={contentDe}
        categories={categories}
        setTitle={setTitle}
        setTitleEn={setTitleEn}
        setTitleDe={setTitleDe}
        setSlug={setSlug}
        setCategoryId={setCategoryId}
        setPostedAt={setPostedAt}
        setActive={setActive}
        setThumbnail={setThumbnail}
        setImage={setImage}
        setContent={setContent}
        setContentEn={setContentEn}
        setContentDe={setContentDe}
      />
    </FormModal>
  );
}
